var map = {
	"./CommunicationsCenter.png": 556,
	"./Distyl-logo.png": 732,
	"./FormBuilder.png": 384,
	"./GoldenGate-1200.jpg": 672,
	"./GoldenGate-2000.jpg": 884,
	"./GoldenGate-3000.jpg": 600,
	"./GoldenGate-4284.jpg": 915,
	"./Headshot.png": 468,
	"./OpenGov-logo.png": 116,
	"./RecordDetails.png": 580,
	"./UVA-logo.png": 296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;